<h1 mat-dialog-title>Add New Schedule</h1>

<form #scheduleForm="ngForm">
  <mat-dialog-content class="dialog-content">
    <div class="dialog-field">
      <mat-form-field>
        <mat-label>Name</mat-label>
        <mat-select
          name="name"
          [(ngModel)]="schedule.name"
          required
          #nameSelect="ngModel">
          @for (field of optionsValues | async; track field) {
            <mat-option [value]="field.key">
              {{ field.value }}
            </mat-option>
          }
        </mat-select>
        @if (nameSelect.hasError('required')) {
          <mat-error> Name is <strong>required</strong></mat-error>
        }
      </mat-form-field>
    </div>

    @if (isFrBeMembershipTypeOption) {
      <gymfinder-alert variant="warning" size="condensed" class="dialog-field">
        <div class="alert-body">
          A Custom schedule only adds or removes this single option: it won't
          remove the other membership type or change the credits configuration,
          which can leave the gym with
          <strong>both Credits and Unlimited</strong>. Use
          <strong>Promote to Unlimited</strong> or
          <strong>Promote to Credits</strong> from the schedule menu instead.
        </div>
      </gymfinder-alert>
    }

    <div class="dialog-field">
      <mat-checkbox name="value" [(ngModel)]="value">
        Check to set the option, leave unchecked to remove it.
      </mat-checkbox>
    </div>

    <div class="dialog-field">
      <mat-form-field>
        <mat-label>Execution Date</mat-label>
        <input
          name="scheduled"
          matInput
          [min]="minDate"
          [matDatepicker]="picker"
          [(ngModel)]="scheduled"
          disabled
          #scheduledDate="ngModel" />
        <mat-hint>YYYY-MM-DD</mat-hint>
        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker #picker disabled="false"></mat-datepicker>
      </mat-form-field>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-raised-button (click)="closeDialog()">Cancel</button>
    <button
      mat-raised-button
      color="primary"
      (click)="add()"
      [disabled]="!scheduleForm.valid">
      Add
    </button>
  </mat-dialog-actions>
</form>
